(function () {
  angular.module('MktzapApp.Controllers')
    .controller('ContactMetadataDefinitionController', contactMetadataDefinitionController);

  contactMetadataDefinitionController.$inject = ['NotificationService', 'ContactMetadataDefinitionService'];

  function contactMetadataDefinitionController (NotificationService, ContactMetadataDefinitionService) {
    var vm = this;
    vm.registerCMD = {};
    vm.params = {};
    vm.registerCMD.id = '';

    loadRegisterCMD();

    function loadRegisterCMD () {
      ContactMetadataDefinitionService
        .all()
        .$promise
        .then(function (data) {
          vm.registerCMDData = data;
        })
        .catch(function (error) {
          NotificationService.errorHandler(error, 'Erro ao carregar Contact Metadata Definition');
        });
    }

    vm.saveOrUpdate = function (id) {
      if (id) {
        update();
      } else {
        save();
      }
    }

    function save () {
      ContactMetadataDefinitionService
        .create(vm.registerCMD)
        .$promise
        .then(function (data) {
          if (data.success) {
            loadRegisterCMD();
            clearRegisterCMD();
            NotificationService.successHandler(data, 'Operação realizada com sucesso');
          } else {
            NotificationService.errorHandler(data, 'Erro na Operação');
          }
        })
        .catch(function (error) {
          NotificationService.errorHandler(error, 'Erro ao salvar Contact Metadata Definition');
        });
    }

    function clearRegisterCMD () {
      vm.registerCMD = {};
    }

    function update () {
      ContactMetadataDefinitionService
        .update(vm.registerCMD)
        .$promise
        .then(function (data) {
          if (data.success) {
            loadRegisterCMD();
            clearRegisterCMD();
            NotificationService.successHandler(data, 'Operação realizada com sucesso');
          } else {
            NotificationService.errorHandler(data, 'Erro na Operação');
          }
        })
        .catch(function (error) {
          NotificationService.errorHandler(error, 'Erro ao salvar Contact Metadata Definition');
        });
    }

    vm.find = function () {
      if (vm.params.search) {
        ContactMetadataDefinitionService
          .find(vm.params)
          .$promise
          .then(function (data) {
            vm.registerCMDData = data.success;
            vm.params.search = '';
          })
          .catch(function (error) {
            NotificationService.errorHandler(error, 'Erro ao realizar busca de Contact Metadata Definition');
          });
      } else {
        loadRegisterCMD();
      }
    }

    vm.editRegisterCMD = function (registerCMD) {
      vm.registerCMD = angular.copy(registerCMD);
    }
  }
})();
